import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c006af14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kunsten-copyright-hover-block" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-copyright" }, null, -1))
const _hoisted_4 = { class: "is-hidden" }
const _hoisted_5 = { class: "kunsten-copyright-hover-tooltip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      tabindex: "0",
      role: "button",
      class: "kunsten-copyright-hover-icon",
      "aria-label": _ctx.$t('general.copyright')
    }, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("general.copyright")), 1)
    ], 8, _hoisted_2),
    _createElementVNode("span", _hoisted_5, [
      _createElementVNode("p", null, _toDisplayString(_ctx.text), 1)
    ])
  ]))
}